interface ErrorStateProps {
  message: string
  onRetry?: () => void
}

export function ErrorState({ message, onRetry }: ErrorStateProps) {
  return (
    <div className="alert alert--error" role="alert">
      <span>{message}</span>
      {onRetry ? (
        <button type="button" className="button button--ghost button--small" onClick={onRetry}>
          Retry
        </button>
      ) : null}
    </div>
  )
}
